// Reusable pagination bar for any list page backed by the shared
// { page, limit, total, totalPages } shape the backend's pagination
// helper (backend/utils/pagination.js) returns.
export default function Pagination({ pagination, onPageChange }) {
  if (!pagination || pagination.totalPages <= 1) return null;

  const { page, limit, total, totalPages } = pagination;
  const firstItem = total === 0 ? 0 : (page - 1) * limit + 1;
  const lastItem = Math.min(page * limit, total);

  return (
    <div className="pagination-bar">
      <span className="pagination-summary">
        Showing {firstItem}-{lastItem} of {total}
      </span>
      <div className="pagination-controls">
        <button type="button" className="btn-secondary" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
          Previous
        </button>
        <span className="pagination-page">
          Page {page} of {totalPages}
        </span>
        <button
          type="button"
          className="btn-secondary"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
}
